import { put, select } from 'redux-saga/effects';

import * as Actions from '../../../actions';
import {
  getCurrentPathnameFromState,
  getNowPlayingPathForId,
  getPandoraIdFromSourceURL,
  isBackstagePath,
} from '../../../lib/RouteUtils';
import { getSourceTypeFromPandoraId } from '../../../lib/SourceTypeUtils';

export function* logInClicked() {
  const path = yield select(getCurrentPathnameFromState);
  // If logging in from a backstage page, redirect to start playback of that source after login
  if (isBackstagePath(path)) {
    const pandoraId = yield select(getPandoraIdFromSourceURL, path);
    const sourceType = getSourceTypeFromPandoraId(pandoraId);
    const redirectUrl = yield select(getNowPlayingPathForId, pandoraId, sourceType);
    yield put(Actions.Login.setAfterLoginRedirect(redirectUrl));
  }
}
